import { Box, styled } from '@mui/material';

export const CardTitle = styled('span')(() => ({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '140%',
  color: '#1A1A1A',
  marginBottom: '16px',
}));

export const CardContainer = styled(Box)(() => ({}));

export const CardContent = styled(Box)(() => ({
  color: '#475667',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  alignSelf: 'stretch',
  alignItems: 'flex-start',
  gap: '24px',
  padding: '24px',
  borderRadius: '8px',
  backgroundColor: '#FFFFFF',

  '& div': {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}));

export const ContentLabel = styled('span')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '140%',
  color: '#475667',
}));

export const CountBadge = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  height: '20px',
  padding: '1px 10px',
  borderRadius: '90px',
  border: '1px solid #EAECF0',
  backgroundColor: '#F2F4F7',
  color: '#475467',
  fontSize: '12px',
  textAlign: 'center',
  fontWeight: 500,
  lineHeight: 'normal',
}));

export const ContentValue = styled('span')(() => ({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '140%',
  color: '#475667',

  display: 'flex',
  alignItems: 'center',
  gap: 4,
}));

type BadgeProps = {
  status: 'active' | 'inactive';
};

const STATUS_COLOR = {
  active: '#00B39B',
  inactive: '#FF4C4C',
};

export const Badge = styled('div')<BadgeProps>(({ status }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: STATUS_COLOR[status],
}));
